import { Swiper, SwiperSlide } from 'swiper/react'
import { FreeMode, Navigation } from 'swiper/modules'
import { CasinoGamesListItem } from './CasinoGamesListItem'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock, faStar } from '@fortawesome/pro-regular-svg-icons'
import { CmsCompetitionDTO } from '@arland-bmnext/webapps-api-data'
import { CasinoSlider } from './CasinoSlider'
import useTranslation from 'next-translate/useTranslation'
import { buildCasinoCategoryUrl } from '../../util/url'
import Link from 'next/link'

export const CasinoGamesCategory = ({
  id = null,
  name = null,
  type,
  icon = '',
  casinoGames,
  layout = 'grid',
  onCasinoGameClick,
  demoModeActive,
  maxGamesToDisplay = null,
  casinoSliderAutoPlayDelay = 3000,
}) => {
  const { t } = useTranslation('common')

  const gamesToDisplay = maxGamesToDisplay ? casinoGames?.slice(0, maxGamesToDisplay) : casinoGames

  return (
    <div className="casino-games-category flex flex-col space-y-3" id={id ? 'casino-category-' + id : undefined}>
      {name && (
        <div className="flex space-x-4 justify-between items-center px-2 md:px-4">
          <div className="flex items-center space-x-2 ">
            {(type === 'popular' || type === 'recently-played' || icon) && (
              <span className="casino-games-category-icon text-primary text-lg">
                {type === 'recently-played' && <FontAwesomeIcon icon={faClock} />}
                {type === 'popular' && <FontAwesomeIcon icon={faStar} />}
                {type === 'custom' && icon && <FontAwesomeIcon icon={['far', icon as any]} />}
              </span>
            )}
            <span className="casino-games-category-name flex text-xl font-semibold">{name}</span>
          </div>
          {(layout === 'cards' || (maxGamesToDisplay && casinoGames?.length > maxGamesToDisplay)) && (
            <Link href={buildCasinoCategoryUrl(id, name)}>
              <span className={'text-primary text-sm font-medium cursor-pointer hover:underline'}>
                {t('Common.showAll')}
              </span>
            </Link>
          )}
        </div>
      )}

      {layout === 'slider' && (
        <CasinoSlider
          casinoGames={gamesToDisplay}
          onCasinoGameClick={onCasinoGameClick}
          casinoSliderAutoPlayDelay={casinoSliderAutoPlayDelay}
        />
      )}

      {layout === 'grid' && (
        <div className="casino-games-category-list-items grid auto-rows-fr grid-cols-2 md:grid-cols-4 xl:grid-cols-6 gap-3 px-2 md:px-4">
          {gamesToDisplay?.map((casinoGame: CmsCompetitionDTO) => (
            <div className="casino-games-category-list-item-wrapper flex h-full overflow-hidden" key={casinoGame.id}>
              <CasinoGamesListItem
                casinoGame={casinoGame}
                onCasinoGameClick={onCasinoGameClick}
                imgAspectRatio="aspect-[4/3]"
                demoModeActive={demoModeActive}
                layout={layout}
              />
            </div>
          ))}
        </div>
      )}

      {layout === 'cards' && (
        <Swiper
          modules={[FreeMode, Navigation]}
          className="casino-games-category-slider-items w-full"
          slidesPerView={'auto'}
          grabCursor
          navigation
          freeMode={{
            enabled: true,
            sticky: true,
          }}
        >
          {gamesToDisplay?.map((casinoGame) => (
            <SwiperSlide
              key={casinoGame.id}
              className={`casino-games-category-slider-slide w-[calc(100%/2)] md:w-[calc(100%/4)] xl:w-[calc(100%/6)] ml-3 first:ml-2 first:md:ml-4 last:mr-2 last:md:mr-4`}
            >
              <div className="casino-games-category-slider-item-wrapper flex h-full">
                <CasinoGamesListItem
                  casinoGame={casinoGame}
                  onCasinoGameClick={onCasinoGameClick}
                  imgAspectRatio="aspect-[3/4]"
                  demoModeActive={demoModeActive}
                  layout={layout}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </div>
  )
}
